import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DefaultPaginatedMeta } from "../../../network/phpClient";
import { ActorProfileMaster, WhoIsInState } from "../../../types";
import { getWhoIsWorking, getWhoIsWorkingDetails } from "./api";
import { set } from "date-fns";

const initialState: WhoIsInState = {
    isLoading: false,
    requestStatus: "FULFILLED",
    employees: [],
    meta: DefaultPaginatedMeta,
    filtersApplied: false,

    isLoadingWhoIsInDetails: false,
    whoIsInDetails: undefined,
    lastFetched: null,
};

const whoIsInSlice = createSlice({
    name: "whoIsIn",
    initialState,
    reducers: {
        setEmployees: (state, action) => {
            state.employees = action.payload;
        },
        setIsLoadingWhoIsInDetails: (state, action) => {
            state.isLoadingWhoIsInDetails = action.payload;
        },
        setWhoIsInDetails: (state, action) => {
            state.whoIsInDetails = action.payload;
        },
        setFiltersApplied: (state, action: PayloadAction<boolean>) => {
            state.filtersApplied = action.payload;
        },
        resetWhoIsInState: () => initialState,
    },
    extraReducers: {
        /** get who is working */
        [getWhoIsWorking.pending.type]: (state) => {
            state.isLoading = true;
            // state.employeeViewStates[EmployeeViewType.WHO_IS_WORKING].isLoading = true;
        },

        [getWhoIsWorking.fulfilled.type]: (state, { payload }) => {
            const { data, meta } = payload;

            if (state.filtersApplied) {
                // If filters are applied, reset the employees list
                state.employees = [];
            }

            // Update meta (pagination details)
            state.meta = meta;

            // Ensure unique employees by filtering duplicates based on `os_emp_account_id`
            const existingIds = new Set(state.employees?.map((emp) => emp.employee_id));
            const newEmployees = data.filter((emp: ActorProfileMaster) => !existingIds.has(emp.employee_id));

            state.employees = [
                ...(state.employees || []),
                ...newEmployees, // Only add unique employees
            ];

            state.isLoading = false; // Reset loading state
            state.requestStatus = "FULFILLED";
            state.lastFetched = Date.now(); // Set lastFetched to now
        },

        [getWhoIsWorking.rejected.type]: (state) => {
            state.isLoading = false;
            state.requestStatus = "REJECTED";
        },

        [getWhoIsWorkingDetails.pending.type]: (state) => {
            state.isLoadingWhoIsInDetails = true;
            state.whoIsInDetails = undefined; // Reset details when loading new data
        },

        [getWhoIsWorkingDetails.fulfilled.type]: (state, { payload }) => {
            state.whoIsInDetails = payload;
            state.isLoadingWhoIsInDetails = false;
        },
        
        [getWhoIsWorkingDetails.rejected.type]: (state) => {
            state.isLoadingWhoIsInDetails = false;
            state.whoIsInDetails = undefined; // Reset details on error
        }
    },
});

export const { setFiltersApplied } = whoIsInSlice.actions;
export default whoIsInSlice.reducer;
